import {Route, Routes} from "react-router-dom";
import './Styles/Style.scss'
import Home from "./Pages/Home";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Programs from "./Pages/Programs";
import About from "./Pages/About";
import Onsite from "./Pages/Onsite";
import Remote from "./Pages/Remote";
import Grad from "./Pages/Grad";
import Workforce from "./Pages/Workforce"
import Contact from "./Pages/Contact";
import CourseDate from "./Pages/CourseDate";
// import Consulting from "./Pages/Consulting";
import Blog from "./Pages/Blog";
import Services from "./Pages/Services";
import ServiceDetail from "./Pages/ServiceDetail";
import Faqs from "./Pages/Faqs";
import ApplyNow from "./Pages/ApplyNow";
import {useEffect} from "react";
import AOS from 'aos';
import StudentTerms from "./Pages/StudentTerms";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsAndConditions from "./Pages/TermsAndConditions";
import NotFound from "./Pages/NotFound";

function App() {
    useEffect(() => {
        AOS.init({
            duration: 1000, // values from 0 to 3000, with step 50ms
            easing: 'ease', // default easing for AOS animations
        });
    }, [])
    return (
        <>
            <Header/>
            <Routes>
                <Route exact path="/" element={<Home/>}/>
                <Route exact path="/programs" element={<Programs/>}/>
                <Route exact path="/about" element={<About/>}/>
                <Route exact path="/on-site" element={<Onsite/>}/>
                <Route exact path="/remote" element={<Remote/>}/>
                <Route exact path="/hire-grad" element={<Grad/>}/>
                <Route exact path="/workforce" element={<Workforce/>}/>
                <Route exact path="/contact" element={<Contact/>}/>
                <Route exact path="/course-date" element={<CourseDate/>}/>
                {/*<Route exact path="/consulting" element={<Consulting/>}/>*/}
                <Route exact path="/blog" element={<Blog/>}/>
                <Route exact path="/our-service" element={<Services/>}/>
                <Route exact path="/service-detail/:course_id" element={<ServiceDetail/>}/>
                <Route exact path="/faqs" element={<Faqs/>}/>
                <Route exact path="/apply-now" element={<ApplyNow/>}/>
                <Route exact path="/student-terms-and-conditions" element={<StudentTerms/>}/>
                <Route exact path="/privacy-policy" element={<PrivacyPolicy/>}/>
                <Route exact path="/terms-and-conditions" element={<TermsAndConditions/>}/>
                <Route path="*" element={<NotFound/>}/>
            </Routes>
            <Footer/>
        </>
    );
}

export default App;
